<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import type { SbColor, SbImage } from '../types';
	import PageGrid16 from '../components/pageGrid16.svelte';
	import Image from '../components/image.svelte';
	import { fade } from 'svelte/transition';

	interface TimelineItem {
		time_label: string;
		headline: string;
		subheadline: string;
		asset: SbImage;
	}

	interface Props {
		content: ISbStoryData<{
			bg_color: SbColor;
			timeline_items: ISbStoryData<TimelineItem>['content'][];
		}>['content'];
	}

	let { content }: Props = $props();

	let topPartHeight = $state(0);
</script>

<div
	class="bg-{content.bg_color} py-8 pb-12 text-brown-1 lg:pb-17 lg:pt-[50px]"
	use:editable={content}
>
	<PageGrid16 class="relative" gridClass="max-lg:flex max-lg:flex-col max-lg:gap-y-8" margin>
		{#each content.timeline_items as item, index}
			<div class="col-span-full text-center lg:col-span-4 lg:col-start-{index * 5 + 2}">
				<div bind:clientHeight={topPartHeight} class="flex flex-col items-center">
					<PageGrid16>
						<Image
							class="aspect-4/3 h-full w-full select-none object-contain"
							wrapperClass="h-full w-full col-start-2 col-end-4 lg:col-span-full"
							src={item.asset.filename}
							alt={item.asset.alt}
							title={item.asset.alt}
							width={1000}
						/>
					</PageGrid16>
					<div class="mt-1 flex select-none justify-center">
						<p
							class="rounded-lg border border-brown-1 px-4 py-2 font-rhymes text-[16px]/[110%] tracking-[-.16px]"
						>
							{item.time_label}
						</p>
					</div>
				</div>
				<div class="mt-5 flex justify-center max-lg:hidden">
					<div class="z-20 h-3 w-3 rounded-full border border-brown-4 bg-{content.bg_color}"></div>
				</div>
				<p
					class="mt-4 text-[24px]/[108%] tracking-[-.24px] lg:text-[24px]/[140%] lg:tracking-[-.24px]"
				>
					{item.headline}
				</p>
				<p class="mt-1 text-balance text-[16px]/[150%] tracking-[-.16px] text-brown-3">
					{item.subheadline}
				</p>
			</div>
		{/each}

		{#if topPartHeight > 0}
			<div in:fade class="absolute w-full max-lg:hidden" style="top: {topPartHeight + 26}px">
				<div class="mx-auto h-[1px] w-[64%] bg-brown-4"></div>
			</div>
		{/if}
	</PageGrid16>
</div>
